<template>
  <div v-if="trimsList && trimsList.length" class="trims_styles mb-4">
    <div v-for="(item, index) in trimsList" :key="index" class="">
      <div class="trims_style_card h-100  text-center cursor_pointer  rounded_10  align-items-center py-3"
        :style="[index === isChecked ? { border: '1px solid' + primaryColor } : { border: '0px solid #fff' }]"
        :class="[{ disabledContent: !isLastIndex }, { 'custom_box_shadow bg-white': !isGradient }, { 'transparent-bgcolor-light': isGradient }]"
        @click.once="eachTrim(item, index)">
        <div class="text-center mb-4" :class="{ gradient_text_white: isGradient }">
          <h4 class="_theme_font_bold text-black mb-0">{{ item.count }}
          </h4>
          <small>in stock</small>
        </div>
        <div class="col-12">
          <h5 class="mb-2 _theme_font_bold" :class="{ gradient_text_white: isGradient }">{{ item.trimName }}
          </h5>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      trimsList: [],
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#000'
    }
  },

  mounted() {

    if (this.botResponse?.component?.values?.length) {
      this.trimsList = this.botResponse?.component?.values;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }

    if (this.isGradient) {
      this.primaryColor = '#fff';
    }

  },
  methods: {
    eachTrim(item, index) {
      let specialObject = { TvmComponentRequest: item };
      ChatWidgetService.postTvmMessage(item.trimName, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction, specialObject);
      this.isChecked = index;
    },
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },

}
</script>
<style lang="less" scoped>
.trims_styles {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.trims_style_card {


  h4 {
    font-size: 55px;
    opacity: 0.5;
    line-height: 1;
  }


  &.disabledContent {
    pointer-events: none !important;
    opacity: 0.9 !important;
  }

  .cursor_pointer {
    cursor: pointer;
  }

  small {
    font-size: 15px;
    display: block;
    min-height: 20px;
  }

}
</style>
